import React, { memo } from "react"
import styled from "styled-components"

import { Flex } from "components/box"

const ArrowDown: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 16 16" fill="#032b24">
    <path fillRule="nonzero" stroke="white" d="M2.343 6L8 11.657 13.657 6" />
  </svg>
)

const ScrollToTopCircle = styled(Flex).attrs({
  justifyContent: "center",
  alignItems: "center",
  height: [75, null, 80],
  width: [75, null, 80]
})`
  background: ${props => props.theme.colors.evergreen};

  transform: rotate(-180deg);
  border-radius: 50%;
  cursor: pointer;
`

const ScrollToTop = () => {
  const handleScrollToTop = () =>
    window?.scroll({
      top: 0,
      behavior: "smooth"
    })

  return (
    <ScrollToTopCircle onClick={handleScrollToTop}>
      <ArrowDown />
    </ScrollToTopCircle>
  )
}

export default memo(ScrollToTop)
